module.exports = __webpack_public_path__ + "img/10th_military.c76a4512.webp";